import { CommentsActions } from 'src/store/actions/commentsActions';
import Utils from 'src/utils';
const initialState = {
    comments: [],
    options: [],
    loading: false
};
const toOptions = (comments) => comments.map(({ Id, Comment }) => ({ label: Comment || '', value: Id }));
export default (state = initialState, { type, payload }) => {
    switch (type) {
        case CommentsActions.LOADING_COMMENTS: {
            return {
                ...state,
                loading: true
            };
        }
        case CommentsActions.NOT_LOADING_COMMENTS: {
            return {
                ...state,
                loading: false
            };
        }
        case CommentsActions.SAVE_COMMENTS: {
            const comments = Utils.arrays.mergeWithNestedObjectsReplace(state.comments, payload, 'Id');
            return {
                ...state,
                comments,
                options: toOptions(comments),
                loading: false
            };
        }
        case CommentsActions.ADD_COMMENT: {
            const comments = [...state.comments, payload];
            return {
                ...state,
                comments,
                options: toOptions(comments),
                loading: false
            };
        }
        case CommentsActions.UPDATE_COMMENT: {
            const comments = Utils.arrays.mergeWithNestedObjectsReplace(state.comments, [payload], 'Id');
            return {
                ...state,
                comments,
                options: toOptions(comments),
                loading: false
            };
        }
        case CommentsActions.DELETE_COMMENT: {
            const comments = state.comments.filter((comment) => comment.Id !== payload);
            return {
                ...state,
                comments,
                options: toOptions(comments),
                loading: false
            };
        }
        case CommentsActions.ERROR: {
            return {
                ...state,
                loading: false
            };
        }
        default: {
            return state;
        }
    }
};
